// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const NonTrackedPinModalHeader = props =>
    <header className='non-tracked-pin-modal-header'>
        <FormattedMessage
            id='CREATE_PRODUCT_RECORD'
        />
        <span
            className='close-modal-icon'
            onClick={props.onClose}
        />
    </header>;

NonTrackedPinModalHeader.displayName = 'NonTrackedPinModalHeader';
NonTrackedPinModalHeader.propTypes = {
    onClose: PropTypes.func.isRequired
};

export default NonTrackedPinModalHeader;



// WEBPACK FOOTER //
// ./src/claim/shared/components/non-tracked-pin-modal/non-tracked-pin-modal-header.js